export default __webpack_public_path__ + "static/media/54.26bd2b2f.png";